<template>
	<div class="px-5">
		<v-col cols="12" class="py-0 group-bread-scrumb">
			<router-link :to="{ name: 'Product' }">
				Quản lý sản phẩm
			</router-link>
			<span> > </span>
			<router-link :to="''"> Chính sách giá và thời hạn </router-link>
		</v-col>
		<div class="create-form">
			<v-col cols="12">
				<div class="group-form">
					<v-row>
						<v-col cols="12 py-0 pt-2 px-8">
							<h3>Chính sách giá và thời hạn</h3>
						</v-col>
						<v-col class="py-0 px-8 pb-3 pt-3 table-product" cols="5">
							<v-simple-table
								class="table-layout table-custom table-sku"
							>
								<thead>
									<tr>
										<th class="col-code">Mã SKU</th>
										<th class="col-name">Tên SKU</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="sku">
										<td>{{ sku.code }}</td>
										<td>{{ sku.name }}</td>
									</tr>
								</tbody>
							</v-simple-table>
						</v-col>
						<v-col class="py-0 px-8 pt-3 pb-3 table-product" cols="12">
							<v-simple-table
								class="table-layout table-custom table-sku"
							>
								<thead>
									<tr>
										<th class="col-start">Ngày bắt đầu*</th>
										<th class="col-end">Ngày kết thúc</th>
										<th class="col-org-price text-center">Giá gốc*</th>
										<th class="col-price-type">Loại giá bán*</th>
										<th class="col-min-price text-center">
											Giá bán tối thiểu*
										</th>
										<th class="col-max-price text-center">
											Giá bán tối đa<span v-if="priceType === 'custom'">*</span>
										</th>
										<th class="col-type">Loại thời hạn</th>
										<th class="col-gift text-center" style="min-width: 120px !important;">
											Thời hạn tặng thêm*
										</th>
										<th class="col-status">
											Trạng thái
										</th>
										<th class="col-create-by text-center">
											Người tạo
										</th>
										<th class="col-action text-center">
											Thao tác
										</th>
									</tr>
								</thead>
								<tbody :key="keyRender">
                  <tr>
                    <td>
                      <date-picker
												:disabled="isExistPending"
												class="datetime-custom"
												format="DD-MM-YYYY HH:mm"
												:minute-options="[]"
												v-model="startDate"
												type="datetime"
												:editable="isEditable"
												placeholder="Ngày bắt đầu"></date-picker>
                    </td>
                    <td>
                      <date-picker
												:disabled="isExistPending"
												class="datetime-custom"
												format="DD-MM-YYYY HH:mm"
												:minute-options="[]"
												v-model="endDate"
												type="datetime"
												:editable="isEditable"
												placeholder="Ngày kết thúc"></date-picker>
                    </td>
                    <td class="text-center" v-if="sku">
											{{ formatCurrency(sku.orgPrice) }}
                    </td>
                    <td class="pt-6">
											<v-select
												:disabled="isExistPending"
												class="text-field v-select-custom"
												:items="priceTypes"
												item-value="id"
												item-text="name"
												:aLight="'right'"
												placeholder="Chọn loại giá bán"
												attach
												outlined
												dense
												v-model="priceType"
												:menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
											></v-select>
                    </td>
                    <td class="pt-6">
                      <v-text-field
												:disabled="isExistPending"
                        class="text-field text-field-number"
                        :clearable="true"
                        placeholder="Nhập giá bán tối thiểu"
                        outlined
                        dense
												type="number"
												v-model="minPrice"
												min="0"
                      ></v-text-field>
                    </td>
                    <td class="pt-6">
                      <v-text-field
												:disabled="isExistPending"
												v-if="priceType == 'custom'"
                        class="text-field text-field-number"
                        :clearable="true"
                        placeholder="Nhập giá bán tối đa"
                        outlined
                        dense
												min="0"
												type="number"
												v-model="maxPrice"
                      ></v-text-field>
                    </td>
                    <td>
											<span v-if="$route.query.sku_type === 'tutor' && sku">
												Theo buổi
											</span>
											<span v-if="$route.query.sku_type === 'duo' && sku">
												<span v-if="sku.durationType == 'month'">Theo tháng</span>
												<span v-if="sku.durationType == 'day'">Theo ngày</span>
											</span>
                    </td>
                    <td class="text-center" :class="{'pt-6': (sku.durationType != 'day')}" v-if="sku">
											<span v-if="sku.durationType == 'day'">--</span>
                      <v-text-field
												v-if="sku.durationType != 'day'"
												:disabled="isExistPending"
                        class="text-field text-field-number"
                        :clearable="true"
                        placeholder="Nhập thời hạn tặng thêm"
                        outlined
                        dense
												type="number"
												min="0"
												max="999"
												v-model="additionalDuration"
                      ></v-text-field>
                    </td>
                    <td class="text-center">--</td>
                    <td class="text-center">
											{{ userId }}
										</td>
                    <td class="text-center">
											<v-tooltip bottom class="mr-2">
												<template v-slot:activator="{ on, attrs }">
													<v-icon :disabled="isExistPending" color="#329D20" v-bind="attrs" v-on="on" @click="addPolicy">
														mdi-check-circle
													</v-icon>
												</template>
												<span>Thêm</span> 
											</v-tooltip>
                    </td>
                  </tr>
									<tr v-if="!data.length">
										<td colspan="11">Không có dữ liệu</td>
									</tr>
                  <tr v-for="(item, index) in data" :key="index" @dblclick="showEdit(item, index)">
                    <td class="text-center">
											<span v-if="!item.isEdit">{{ dateCus(item.startDate) }}</span>
											<date-picker
												v-if="item.isEdit"
												class="datetime-custom"
												format="DD-MM-YYYY HH:mm"
												v-model="item.startDate"
												:minute-options="[]"
												type="datetime"
												:editable="isEditable"
												:disabled="item.status != 'pending'"
												placeholder="Ngày bắt đầu"></date-picker>
										</td>
                    <td class="text-center">
											<span v-if="!item.isEdit">{{ item.endDate ? dateCus(item.endDate) : '--' }}</span>
											<date-picker
												v-if="item.isEdit"
												class="datetime-custom"
												format="DD-MM-YYYY HH:mm"
												v-model="item.endDate"
												:minute-options="[]"
												type="datetime"
												:editable="isEditable"
												:disabled="isDisableEndDate(item)"
												placeholder="Ngày kết thúc"></date-picker>
										</td>
                    <td class="text-center">
											<span v-if="sku">{{ item.orgPrice ? formatCurrency(item.orgPrice) : formatCurrency(sku.orgPrice) }}</span>
										</td>
                    <td>
											<span v-if="!item.isEdit">
												<span v-for="(type, idt) in priceTypes" :key="index + '' + idt">
													<span v-if="type.id === item.priceType">{{ type.name }}</span>
												</span>
											</span>
											<v-select
												v-if="item.isEdit"
												class="text-field v-select-custom mt-5"
												:items="priceTypes"
												item-value="id"
												item-text="name"
												:aLight="'right'"
												placeholder="Chọn loại giá bán"
												attach
												outlined
												dense
												v-model="item.priceType"
												@change="item.maxPrice = null"
												:disabled="item.status != 'pending'"
												:menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
											></v-select>
										</td>
                    <td class="text-center">
											<span v-if="!item.isEdit">{{ formatCurrency(item.minPrice) }}</span>
											<v-text-field
												v-if="item.isEdit"
                        class="text-field mt-5 text-field-number"
                        :clearable="true"
                        placeholder="Nhập giá bán tối thiểu"
                        outlined
                        dense
												type="number"
												v-model="item.minPrice"
												:disabled="item.status != 'pending'"
												min="0"
                      ></v-text-field>
										</td>
                    <td class="text-center">
											<span v-if="!item.isEdit || item.priceType == 'unchanged'">{{ item.maxPrice ? formatCurrency(item.maxPrice) : '--' }}</span>
											<v-text-field
												v-if="item.priceType == 'custom' && item.isEdit"
                        class="text-field mt-5 text-field-number"
                        :clearable="true"
                        placeholder="Nhập giá bán tối đa"
                        outlined
                        dense
												min="0"
												type="number"
												v-model="item.maxPrice"
												:disabled="item.status != 'pending'"
                      ></v-text-field>
										</td>
                    <td>
											<span v-if="$route.query.sku_type === 'tutor' && sku">
												Theo buổi
											</span>
											<span v-if="$route.query.sku_type === 'duo' && sku">
												<span v-if="sku.durationType == 'month'">Theo tháng</span>
												<span v-if="sku.durationType == 'day'">Theo ngày</span>
											</span>
										</td>
                    <td class="text-center" v-if="$route.query.sku_type === 'duo'">
											<span v-if="!item.isEdit && sku">{{ item.additionalDuration || item.additionalDuration == 0 ? item.additionalDuration : '--' }}</span>
											<v-text-field
												v-if="item.isEdit && sku && sku.durationType != 'day'"
                        class="text-field mt-5 text-field-number"
                        :clearable="true"
                        placeholder="Nhập thời hạn tặng thêm"
                        outlined
                        dense
												type="number"
												:disabled="item.status != 'pending'"
												min="0"
												v-model="item.additionalDuration"
                      ></v-text-field>
										</td>
										<td class="text-center" v-if="$route.query.sku_type === 'tutor'">
											<span v-if="!item.isEdit">{{ item.additionalNumOfLesson }}</span>
											<v-text-field
												v-if="item.isEdit"
                        class="text-field mt-5 text-field-number"
                        :clearable="true"
                        placeholder="Nhập thời hạn tặng thêm"
                        outlined
                        dense
												type="number"
												:disabled="item.status != 'pending'"
												min="0"
												v-model="item.additionalNumOfLesson"
                      ></v-text-field>
										</td>
                    <td>
											<span v-if="item.status === 'pending'">Chưa bắt đầu</span>
											<span v-if="item.status === 'active'">Đang áp dụng</span>
											<span v-if="item.status === 'finished'">Đã kết thúc</span>
											<span v-if="item.status === 'cancelled'">Đã hủy</span>
										</td>
										<td class="text-center">{{ item.createdBy ? item.createdBy : 'SYSTEM' }}</td>
                    <td class="text-center">
											<v-tooltip v-if="item.isEdit" bottom class="mr-2">
												<template v-slot:activator="{ on, attrs }">
													<v-icon color="#329D20" v-bind="attrs" v-on="on" @click="saveItem(item, index)">
														mdi-check-circle
													</v-icon>
												</template>
												<span>Cập nhật</span> 
											</v-tooltip>
											<v-tooltip v-if="!item.isEdit && ['pending', 'active'].includes(item.status)" bottom class="mr-2">
												<template v-slot:activator="{ on, attrs }">
													<v-icon color="#329D20" v-bind="attrs" v-on="on" @click="showEdit(item, index)">
														mdi-check-circle
													</v-icon>
												</template>
												<span>Cập nhật</span> 
											</v-tooltip>
											<v-tooltip bottom v-if="item.status === 'pending'">
													<template v-slot:activator="{ on }">
															<v-icon v-on="on" class="ml-3 cursor-pointer" color="#959595" @click="cancelPolicy(item, index)">
																	mdi-delete
															</v-icon>
													</template>
													<span>Hủy</span>
											</v-tooltip>
										</td>
                  </tr>
									<tr
										v-if="data.length < 4"
										class="tr-no-data"
									>
										<td colspan="10"></td>
									</tr>
								</tbody>
							</v-simple-table>
						</v-col>
						<v-col cols="12" v-if="totalPage">
							<v-row>
								<v-col offset="4" cols="8" class="py-0">
									<v-row>
										<v-col cols="7" class="d-flex justify-end py-0">
											<p class="pt-3">Rows per page:</p>
										</v-col>
										<v-col cols="1" class="justify-end py-0">
											<v-select
												class="text-field"
												:items="[{ id: 10 },{ id: 20 },{ id: 30 },{ id: 40 },{ id: 50 }]"
												item-value="id"
												item-text="id"
												:aLight="'right'"
												placeholder="Chọn"
												attach
												dense
												v-model="numPerPage"
												@change="getList(1)"
												:menu-props="{ top: true, offsetY: true, maxHeight: '150' }"
											></v-select>
										</v-col>
										<v-col cols="1" class="justify-center py-0">
											<p class="pt-3 text-center">
												{{ (page - 1) * numPerPage + 1 }}-{{ (page - 1) * numPerPage + data.length }} of {{ totalItem }}
											</p>
										</v-col>
										<v-col cols="3" class="py-0">
											<v-pagination
												v-model="page"
												class="d-flex justify-end pagination-custom"
												:length="totalPage"
												:total-visible="7"
												@input="getSkuPricePolicies()"
											></v-pagination>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</div>
			</v-col>
		</div>
	</div>
</template>

<script>
import * as moment from "moment";

import TokenService from '../../helpers/token';

import {
	productTypeDuo,
	productTypeTutor,
	productTypeCombo,
} from "../../helpers/constants";

import RepositoryFactory from "@/repositories/RepositoryFactory";
const ProductRepository = RepositoryFactory.get("product");

import Product from "./models/Product";
import SkuDuo from "./models/SkuDuo";
import SkuCombo from "./models/SkuCombo";
import SkuTutor from "@/pages/product-management/models/SkuTutor";
import { formatDate } from "@/helpers/utils";

export default {
	name: "detail",
	components: {},
	props: {
	},
	data() {
		return {
			isEditable: false,
			keyRender: 0,
      startDate: null,
      endDate: null,
      priceType: null,
      minPrice: null,
      maxPrice: null,
      additionalDuration: null,
			product: new Product({}),
			productTypeDuo,
			productTypeTutor,
			productTypeCombo,
			data: [],
			productId: null,
			sku: null,
			skuPricePolicies: [],
			totalPage: 0,
			page: 1,
			numPerPage: 20,
			priceTypes: [
				{
					id: 'custom',
					name: 'Tùy chọn',
				},
				{
					id: 'unchanged',
					name: 'Cố định',
				},
			],
			userId: null,
			totalItem: 0,
		};
	},
	computed: {
    currentDate() {
      return moment().format('YYYY-MM-DD');
    },
		isExistPending() {
			return !!this.data.find((item) => item.status === 'pending');
		},
  },
  watch: {
	priceType(val) {
		if (val === 'unchanged') {
			this.minPrice = this.sku.orgPrice
		}
	}
  },
	async created() {
		if (this.$route.params.id) {
			this.getDetail(this.$route.params.id);
			this.productId = parseInt(this.$route.params.id);
			this.getSkuPricePolicies();
		}
		this.userId = TokenService.getId()
	},
	beforeDestroy() {},
	methods: {
		isDisableEndDate(item) {
			console.log('object,', (!item.createdBy || ['finished','cancelled' ].includes(item.status)));
			return (!item.createdBy || ['finished','cancelled' ].includes(item.status));
			// return false;
		},
		dateCus(data) {
			return moment(data).format('DD-MM-YYYY HH:mm');
		},
		compare(a, b) {
			if (b.id > a.id) {
				return 1;
			}
			if (a.id > b.id) {
				return -1;
			}
			return 0;
		},
		showEdit(item, index) {
			if (moment(item.endDate).isBefore(this.currentDate) || item.status === 'finished' || !item.createdBy) {
				return;
			}
			item.isEdit = true;
			this.keyRender++;
		},
		async saveItem(item, index) {
			if (!item.startDate) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Chưa chọn ngày bắt đầu',
				});
			}
			if (!item.priceType) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Chưa chọn loại giá bán',
				});
			}
			if (!item.minPrice && item.minPrice !== 0 ) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Chưa nhập giá bán tối thiểu',
				});
			}
			if (item.minPrice && parseInt(item.minPrice) < 0) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Giá bán tối thiểu không được phép nhập số âm',
				});
			}
			if (item.maxPrice && parseInt(item.maxPrice) < 0) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Giá bán tối đa không được phép nhập số âm',
				});
			}
			if (item.minPrice && `${item.minPrice}`.includes('.')) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Giá bán tối thiểu chỉ được phép nhập số nguyên',
				});
			}

			if (item.minPrice && `${item.minPrice}`.length > 10) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Giá bán tối thiểu không được quá 10 kí tự',
				});
			}

			if (item.maxPrice && parseInt(item.minPrice) > parseInt(item.maxPrice)) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Giá bán tối đa không hợp lệ.',
				});
			}
			if (item.maxPrice && `${item.maxPrice}`.includes('.')) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Giá bán tối đa chỉ được phép nhập số nguyên',
				});
			}
			if (item.maxPrice && `${item.maxPrice}`.length > 10) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Giá bán tối đa không được quá 10 kí tự',
				});
			}
			if (item.priceType == 'custom' && !item.maxPrice) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Chưa nhập giá bán tối đa',
				});
			}
			if (this.$route.query.sku_type === 'duo' && this.sku.durationType != 'day') {
				if (!item.additionalDuration && item.additionalDuration != 0 || `${item.additionalDuration}` == '') {
					console.log('1', item.additionalDuration);
					return this.$swal({
						type: 'error',
						title: 'Lỗi !',
						text: 'Chưa nhập thời hạn tăng thêm',
					});
				}
				if (item.additionalDuration && parseInt(item.additionalDuration) < 0) {
					return this.$swal({
						type: 'error',
						title: 'Lỗi !',
						text: 'Thời hạn tăng thêm không cho phép nhập số âm',
					});
				}
				if (item.additionalDuration && `${item.additionalDuration}`.length > 3) {
					return this.$swal({
						type: 'error',
						title: 'Lỗi !',
						text: 'Thời hạn tăng thêm không được quá 3 kí tự',
					});
				}
				if (item.additionalDuration && `${item.additionalDuration}`.includes('.')) {
					return this.$swal({
						type: 'error',
						title: 'Lỗi !',
						text: 'Thời hạn tăng thêm chỉ được phép nhập số nguyên',
					});
				}
			}
			if (this.$route.query.sku_type === 'tutor') {
				if (!item.additionalNumOfLesson && item.additionalNumOfLesson != 0 || `${item.additionalNumOfLesson}` == '') {
					return this.$swal({
						type: 'error',
						title: 'Lỗi !',
						text: 'Chưa nhập thời hạn tăng thêm',
					});
				}
				if (item.additionalNumOfLesson && parseInt(item.additionalNumOfLesson) < 0) {
					return this.$swal({
						type: 'error',
						title: 'Lỗi !',
						text: 'Thời hạn tăng thêm không cho phép nhập số âm',
					});
				}
				if (item.additionalNumOfLesson && `${item.additionalNumOfLesson}`.length > 3) {
					return this.$swal({
						type: 'error',
						title: 'Lỗi !',
						text: 'Thời hạn tăng thêm không được quá 3 kí tự',
					});
				}
				if (item.additionalNumOfLesson && `${item.additionalNumOfLesson}`.includes('.')) {
					return this.$swal({
						type: 'error',
						title: 'Lỗi !',
						text: 'Thời hạn tăng thêm chỉ được phép nhập số nguyên',
					});
				}
			}
			if (item.endDate && moment(item.startDate).isSameOrAfter(item.endDate)) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Ngày kết thúc phải lớn hơn ngày bắt đầu',
				});
			}
			const body = {
				skuType: this.$route.query.sku_type,
				skuId: this.$route.params.sku_id,
				startDate: moment(item.startDate).format('YYYY-MM-DD HH:mm'),
				endDate: (item.endDate) ? moment(item.endDate).format('YYYY-MM-DD HH:mm') : null,
				priceType: item.priceType,
				minPrice: (item.minPrice || item.minPrice === 0) ? parseInt(item.minPrice) : null,
				maxPrice: item.maxPrice ? parseInt(item.maxPrice) : null,
			};
			if (this.$route.query.sku_type === 'duo') {
				body.additionalDuration = item.additionalDuration;
			}
			if (this.$route.query.sku_type === 'tutor') {
				body.additionalNumOfLesson = parseInt(item.additionalNumOfLesson);
			}
			if (item.priceType != 'custom') {
				delete body.maxPrice;
			}

			const res = await ProductRepository.updatePolicy(item.id, body);
			if (res && res.data) {
				this.$swal({
					type: "success",
					icon: "success",
					title: "Cập nhật thành công!",
					toast: true,
					showConfirmButton: false,
					timer: 1500,
				});
				this.getSkuPricePolicies();
				item.isEdit = false;
				this.keyRender++;
			} else {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: res.errors.message,
				});
			}
		},
		async getDetail(id) {
			const res = await ProductRepository.getDetail(id);
			this.product = new Product(res.data);
			this.getListSku();
		},
		async getListSku(search= {}) {
      this.skuItems = [];
      const params = {
        product_id: this.product.id,
        product_type: this.product.type,
        ...search
      };
      const res = await ProductRepository.advanceSearchForCombo(params);
			this.sku = res.data.find((item) => item.id == this.$route.params.sku_id)
    },
		cancel() {
			// this.$swal
			// 	.fire({
			// 		title: "Bạn muốn đóng form? Tất cả thông tin sẽ bị mất!",
			// 		icon: "warning",
			// 		showCancelButton: true,
			// 		cancelButtonText: "Hủy",
			// 		confirmButtonColor: "#3085d6",
			// 		cancelButtonColor: "#d33",
			// 		confirmButtonText: "Đồng ý",
			// 	})
			// 	.then(async (result) => {
			// 		if (result?.value) {
			// 			this.$router.push("/products");
			// 		}
			// 	});
		},
		async cancelPolicy(item, index) {
			const body = {
				skuType: this.$route.query.sku_type,
    		status: "cancelled"
			};
			const res = await ProductRepository.updateStatusPolicy(item.id, body);
			if (res && res.data) {
				this.$swal({
					type: "success",
					icon: "success",
					title: "Hủy thành công!",
					toast: true,
					showConfirmButton: false,
					timer: 1500,
				});
				this.getSkuPricePolicies();
			}
		},
		async getSkuPricePolicies() {
			const params = {
				sku_type: this.$route.query.sku_type,
				page: this.page,
				limit: this.numPerPage,
				sku_id: this.$route.params.sku_id,
			};
			const res = await ProductRepository.getSkuPricePolicies(params);
			this.data = res.data;
			this.totalPage = Math.ceil(res.totalItem / this.numPerPage);
			this.totalItem = res.totalItem;
			this.data.forEach((item) => {
				item.isEdit = false;
				item.startDate = new Date(item.startDate);
				if (item.endDate) {
					item.endDate = new Date(item.endDate);
				}
			})
		},
		async addPolicy() {
			if (!this.startDate) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Chưa chọn ngày bắt đầu',
				});
			}
			if (!this.priceType) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Chưa chọn loại giá bán',
				});
			}
			if (!this.minPrice) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Chưa nhập giá bán tối thiểu',
				});
			}
			if (this.minPrice && `${this.minPrice}`.includes('.')) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Giá bán tối thiểu chỉ được phép nhập số nguyên',
				});
			}
			if (this.maxPrice && `${this.maxPrice}`.includes('.')) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Giá bán tối đa chỉ được phép nhập số nguyên',
				});
			}
			if (this.minPrice && parseInt(this.minPrice) < 0) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Giá bán tối thiểu không được phép nhập số âm',
				});
			}
			if (this.minPrice && `${this.minPrice}`.length > 10) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Giá bán tối thiểu không được quá 10 kí tự',
				});
			}
			if (this.maxPrice && `${this.maxPrice}`.length > 10) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Giá bán tối đa không được quá 10 kí tự',
				});
			}
			if (this.maxPrice && parseInt(this.maxPrice) < 0) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Giá bán tối đa không được phép nhập số âm',
				});
			}
			if (this.maxPrice && parseInt(this.minPrice) >= parseInt(this.maxPrice)) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Giá bán tối đa không hợp lệ.',
				});
			}
			if (this.priceType == 'custom' && !this.maxPrice) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Chưa nhập giá bán tối đa',
				});
			}
			if (!this.additionalDuration && this.sku.durationType != 'day') {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Chưa nhập thời hạn tăng thêm',
				});
			}
			if (this.additionalDuration && parseInt(this.additionalDuration) < 0) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Thời hạn tăng thêm không cho phép nhập số âm',
				});
			}
			if (this.additionalDuration && `${this.additionalDuration}`.length > 3) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Thời hạn tăng thêm không được quá 3 kí tự',
				});
			}
			if (this.additionalDuration && `${this.additionalDuration}`.includes('.')) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Thời hạn tăng thêm chỉ được phép nhập số nguyên',
				});
			}
			if (moment(this.currentDate).isAfter(this.startDate)) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Ngày bắt đầu phải lớn hơn thời điểm hiện tại',
				});
			}
			if (this.endDate && moment(this.startDate).isSameOrAfter(this.endDate)) {
				return this.$swal({
					type: 'error',
					title: 'Lỗi !',
					text: 'Ngày kết thúc phải lớn hơn ngày bắt đầu',
				});
			}
			const body = {
				skuType: this.$route.query.sku_type,
				skuId: this.$route.params.sku_id,
				startDate: moment(this.startDate).format('YYYY-MM-DD HH:mm'),
				endDate: (this.endDate) ? moment(this.endDate).format('YYYY-MM-DD HH:mm') : null,
				priceType: this.priceType,
				minPrice: (this.minPrice || this.minPrice === 0) ? parseInt(this.minPrice) : null,
				maxPrice: this.maxPrice ? parseInt(this.maxPrice) : null,
				additionalDuration: this.additionalDuration,
			};

			if (this.$route.query.sku_type === 'tutor') {
				delete body.additionalDuration;
				body.additionalNumOfLesson = parseInt(this.additionalDuration);
			}

			if (this.priceType != 'custom') {
				delete body.maxPrice;
			}

			const res = await ProductRepository.createPolicy(body);
			if (res && res.data) {
				this.$swal({
					type: "success",
					icon: "success",
					title: "Thêm thành công!",
					toast: true,
					showConfirmButton: false,
					timer: 1500,
				});
				this.getSkuPricePolicies();
				this.startDate = null;
				this.endDate = null;
				this.priceType = null;
				this.minPrice = null;
				this.maxPrice = null;
				this.additionalDuration = null;
				body.additionalNumOfLesson = null;
			} else {
				if (res.errors) {
					return this.$swal({
						type: 'error',
						title: 'Lỗi !',
						text: res.errors.message,
					});
				}
				return this.$swal({
						type: 'error',
						title: 'Lỗi !',
						text: res.message,
					});
			}
		},
	},
};
</script>
<style scoped lang="scss">
.btn-save {
	background: #8465ff !important;
	color: #fff;
}
.btn-cancel {
	background: #787878 !important;
	color: #fff;
}
.create-form {
	background: #fff;
}
.group-form {
	background: #fafbff;
	border-radius: 10px;
	box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
}
.text-bold {
	font-weight: bold;
}

.btn-info {
	background: #6587ff !important;
	color: #fff;
}

.icon-search {
	left: 40px;
	position: relative;
}
.table-custom {
	th {
		min-width: 40px;
		background: #e7e8ff;
		border-left: 1px solid #fff;
	}
}
.col-start {
	width: 11% !important;
}
.col-end {
	width: 11% !important;
}
.col-org-price {
	width: 8% !important;
}
.col-price-type {
	width: 8% !important;
}
.col-min-price {
	width: 11% !important;
}
.col-max-price {
	width: 11% !important;
}
.col-type {
	width: 8% !important;
}
.col-gift {
	width: 8% !important;
}
.col-status {
	width: 8% !important;
}
.col-create-by {
	width: 8% !important;
}
.col-action {
	width: 8% !important;
}
</style>

<style lang="scss">
.text-field fieldset {
	background: #fff !important;
}
.text-search {
	.v-input__slot {
		min-height: 20px !important;
		padding-left: 35px !important;
	}
}

.v-select-custom {
	.v-subheader {
		font-weight: bold;
		background: #ececec;
		color: #000;
	}
}

.group-bread-scrumb {
	position: relative;
	top: -30px;
	z-index: 99;
	height: 0;
	font-weight: bold;
	font-size: 17px;
	a {
		text-decoration: none !important;
		color: #000;
	}
}

.datetime-custom {
	width: 100%;
}
.pagination-custom {
  li button{
    box-shadow: none !important;
		color: #3F51B5 !important;
  }

	.v-pagination__item--active {
		color: #000 !important;
		background: #fff !important;
	}
}

</style>
